export default __webpack_public_path__ + "static/filter-button-metric-do-dark-8022446ae16f1a30edce4f0c5c1f918f.png";